/**
 * Gets element offset top from the top of the screen
 */
const findYPos = (element: HTMLElement): number => {
  let topPosition = 0

  if (element.offsetParent) {
    do {
      topPosition += element.offsetTop
    }
    while (element = <HTMLElement>element.offsetParent)
  }

  return topPosition
}

/**
 * Scrolls document to a specified element
 */
const scrollToElement = (
  elementOrElementId: HTMLElement | string, smooth: boolean = false,
  compesation: number = 0, onlyUp: boolean = false
): void => {
  let element: HTMLElement

  if (typeof elementOrElementId === 'string') {
    element = document.getElementById(elementOrElementId)
  }
  else {
    element = elementOrElementId
  }

  if (element) {
    const elementOffsetTop  = findYPos(element)
    const isSmooth          = smooth && typeof window.scroll === 'function'
    const scrollTop         = document.body.scrollTop || document.documentElement.scrollTop
    const offsetTop         = (elementOffsetTop + compesation) || 0

    if (!onlyUp || scrollTop > elementOffsetTop) {
      if (isSmooth) {
        try {
          window.scroll({
            top: offsetTop,
            left: 0,
            behavior: 'smooth',
          })
        }
        catch (err) {
          window.scrollTo(0, offsetTop)
        }
      }
      else {
        window.scrollTo(0, offsetTop)
      }
    }
  }
  else {
    console.warn(`Element '${elementOrElementId}' not found`)
  }
}


export default scrollToElement
